
import { sortBy } from 'lodash';
import { Component, Emit, InjectReactive, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class';

import SetLocation from '@/components/SetLocation.vue';
import SingleLocation from '@/components/SingleLocation.vue';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    SingleLocation,
    SetLocation,
  }
})
export default class MyLocation extends Vue {
    @Getter allRestaurants!: Restaurant[];
    @Getter activeRestaurant!: Restaurant;
    @InjectReactive() viewContainerRef!: any;

    get sortedRestaurants() {
      return sortBy(this.allRestaurants, ['distanceFromUser', 'name']);
    }

    @Emit('preview-location')
    showLocation(location) {
      return location;
    }

    @Emit('set-location')
    selectedLocation(location) {
      return location;
    }

    get address(): CustomerLocation {
      return UserModule.address;
    }

    get formattedAddress(): string {
      return UserModule.address?.placeInfo?.formatted_address;
    }
}
